const viewportActiveClassName = 'animations-in-viewport--active';
const pendingClassName = 'info-trips__illustration--pending';

export function initAdvantagesInfoTrips() {
    const targets = Array.from(document.querySelectorAll('[data-info-trips-viewport]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!targets.length || reducedMotion.matches) {
        return;
    }

    const observers = [];
    targets.forEach((target) => {
        let hasStarted = false;
        let observer;
        const startIllustration = () => {
            if (hasStarted) {
                return;
            }
            hasStarted = true;
            if (observer) {
                observer.disconnect();
            }
            target.classList.remove(pendingClassName);
            if (reducedMotion.matches) {
                return;
            }

            target.querySelectorAll('[data-info-trips-bar-color]').forEach((bar) => {
                bar.animate([{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }], {
                    duration: 850, delay: 180, easing: 'ease-out', fill: 'backwards',
                });
            });
        };

        target.classList.add(pendingClassName);
        if (target.classList.contains(viewportActiveClassName)) {
            const image = target.querySelector('.info-trips__item--real-time-employee-image');
            if (image) {
                // Commit the starting position when the viewport hook is already active.
                image.getBoundingClientRect();
            }
            startIllustration();
        } else {
            observer = new MutationObserver(() => {
                if (target.classList.contains(viewportActiveClassName)) {
                    startIllustration();
                }
            });
            observer.observe(target, { attributes: true, attributeFilter: ['class'] });
            observers.push(observer);
        }
    });

    reducedMotion.addEventListener('change', () => {
        if (!reducedMotion.matches) {
            return;
        }
        observers.forEach((observer) => observer.disconnect());
        targets.forEach((target) => {
            target.classList.remove(pendingClassName);
            target.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
        });
    });
}
